import React from 'react';

/**
 * 🎭🎬 THE BALLOT INVITATION (LIGHTHOUSE_SCREENING_SPEC §12, Nina 09-20 late).
 * A poll-LOOKING card for a visitor who has not voted in the stage that is
 * open (genre, then film). It is NOT a room poll: only this viewer sees it, it
 * never touches `space_poll`, it has no countdown, and "not now" only hides it
 * for this visit. The 📅 door is the permanent home (vote or switch any time).
 * `invite` = calendarView.ballotInvite(house.ballot). One tap votes.
 */
export default function GenreVoteCard({ invite, onVote, onDismiss, THEME = {} }) {
  if (!invite || !Array.isArray(invite.options) || !invite.options.length) return null;
  const accent = THEME.accent || '#7b1fa2';
  const max = Math.max(1, ...invite.options.map((o) => o.votes));
  return (
    <div data-ballot-invite={invite.stage} style={{
      margin: '0 0 8px', padding: '10px 12px', borderRadius: 10, boxSizing: 'border-box', maxWidth: '100%',
      background: THEME.bgLight || 'rgba(20,16,30,0.92)', border: `1px solid ${accent}55`, boxShadow: '0 4px 14px rgba(0,0,0,0.3)',
    }}>
      <style>{'.ballot-invite-opt{touch-action:manipulation;-webkit-tap-highlight-color:transparent;transition:border-color 0.12s ease, transform 0.08s ease} .ballot-invite-opt:active{transform:scale(0.985)}'}</style>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: '0.68em', fontWeight: 800, letterSpacing: '0.1em', color: accent }}>🎬 MOVIE NIGHT VOTE</span>
        {onDismiss && (
          <button type="button" aria-label="Not now" title="Not now" onClick={onDismiss}
            style={{ marginLeft: 'auto', background: 'transparent', border: 'none', cursor: 'pointer', color: THEME.textMuted || '#999', fontSize: '0.85em', padding: '0 2px', lineHeight: 1 }}>
            ✕
          </button>
        )}
      </div>
      <div style={{ fontSize: '0.9em', fontWeight: 700, color: THEME.text || '#eee', marginBottom: 8, overflowWrap: 'anywhere' }}>{invite.question}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        {invite.options.map((o) => (
          <button key={o.cmd} type="button" className="ballot-invite-opt" data-ballot-invite-opt={o.cmd} onClick={() => onVote && onVote(o.cmd)}
            style={{
              position: 'relative', overflow: 'hidden', textAlign: 'left', width: '100%', boxSizing: 'border-box', cursor: 'pointer', font: 'inherit',
              padding: '7px 10px', borderRadius: 8, background: 'rgba(255,255,255,0.04)', border: `1px solid ${accent}40`, color: THEME.text || '#eee',
            }}>
            <span aria-hidden="true" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: `${Math.round((100 * o.votes) / max)}%`, background: `${accent}22` }} />
            <span style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'baseline' }}>
              <span style={{ minWidth: 0 }}>
                <b style={{ fontSize: '0.88em', overflowWrap: 'anywhere' }}>{o.title}</b>
                {o.meta ? <span style={{ fontSize: '0.72em', color: THEME.textMuted || '#999' }}> · {o.meta}</span> : null}
                {o.pitch ? <span style={{ display: 'block', fontSize: '0.76em', color: THEME.textMuted || '#aaa', overflowWrap: 'anywhere' }}>{o.pitch}</span> : null}
              </span>
              <span style={{ fontSize: '0.74em', color: THEME.textMuted || '#999', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{o.votes}</span>
            </span>
          </button>
        ))}
      </div>
      <div style={{ fontSize: '0.72em', color: THEME.textMuted || '#999', marginTop: 7 }}>{invite.hint}</div>
    </div>
  );
}
